import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetActividadesConfiguracion } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionActividadesService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/configuracion-actividades`;

  constructor(private readonly http: HttpClient) {}

  getActividadesConfiguracion(tipoId: number): Observable<IGetActividadesConfiguracion[]> {
    return this.http.get<IGetActividadesConfiguracion[]>(`${this.apiUrl}/tipo/${tipoId}`);
  }

}
